import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingOtherCustomerModel } from '../../customer-billing-other-customer/customer-billing-other-customer.model';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { CustomerService } from '../../customer-billing-customer/customer.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-customer-billing-reseller-edit',
    template: `
        <fi-edit-tabs [editTabsSettings]="EditTabs" [isNewHeaderLayout]="true" (save)="Save()">
            <div class="content-card-wrapper ExtraLightBackgroundColor" tab0>
                <mat-card class="content-card">
                    <fi-customer-billing-reseller-info
                        [sectionText]="'billing.reseller_information' | fiAppText"
                        [nameInputLabel]="'company_name' | fiAppText"
                        [(ngModel)]="customer"
                    >
                    </fi-customer-billing-reseller-info>

                    <fi-customer-billing-reseller-payment-info [(ngModel)]="customer">
                    </fi-customer-billing-reseller-payment-info>

                    <fi-customer-billing-reseller-invoice-info [(ngModel)]="customer">
                    </fi-customer-billing-reseller-invoice-info>
                </mat-card>
            </div>
        </fi-edit-tabs>
    `,
    styleUrls: ['./customer-billing-reseller-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-reseller-edit' },
    standalone: false,
})
export class CustomerBillingResellerEditComponent implements OnInit {
    @Input() customer: CustomerBillingOtherCustomerModel;

    EditTabs: EditTabsModel;

    constructor(
        private appTextService: AppTextService,
        private customerService: CustomerService,
        private fiLoadingService: LoadingService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
    ) {}

    ngOnInit() {
        this.setHeaderPageData();
    }

    private setHeaderPageData() {
        this.EditTabs = new EditTabsModel(this.getPageTitle());
        this.EditTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    private getPageTitle(): string {
        return this.customer.Id
            ? this.objectTitleService.getEditTitle(this.customer.Name)
            : this.objectTitleService.getCreateTitle(ObjectTypes.CustomerBillingReseller);
    }

    Save() {
        this.fiLoadingService.trackPromise(this.customerService.SaveOtherBillingCustomer(this.customer)).then(() => {
            this.stateService.go(FiStateNames.CustomerBilling.Resellers.List);
        });
    }
}
